export default __webpack_public_path__ + "static/media/login-photo.60592668.jpg";